import type { DefaultDashboardDefinition } from './dashboard-definition';

export const financeDashboard: DefaultDashboardDefinition = {
  id: "finance.main",
  appId: "finance",
  name: "Finance dashboard",
  record: null,
  queryScope: null,
  placements: [
    {id:'finance.quarterly-revenue-profit.default',widgetId:'finance.quarterly-revenue-profit',placement:{x:0,y:28,width:12,height:5}},
    {
      id: "finance.profit-trend.default",
      widgetId: "finance.profit-trend",
      placement: {
        x: 0,
        y: 0,
        width: 6,
        height: 3,
      },
    },
    {
      id: "finance.receivables-trend.default",
      widgetId: "finance.receivables-trend",
      placement: {
        x: 6,
        y: 0,
        width: 3,
        height: 3,
      },
    },
    {
      id: "finance.payables-trend.default",
      widgetId: "finance.payables-trend",
      placement: {
        x: 9,
        y: 0,
        width: 3,
        height: 3,
      },
    },
    {
      id: "finance.debits.default",
      widgetId: "finance.debits",
      placement: {
        x: 0,
        y: 3,
        width: 3,
        height: 1,
      },
    },
    {
      id: "finance.credits.default",
      widgetId: "finance.credits",
      placement: {
        x: 3,
        y: 3,
        width: 3,
        height: 1,
      },
    },
    {
      id: "finance.profit.default",
      widgetId: "finance.profit",
      placement: {
        x: 6,
        y: 3,
        width: 3,
        height: 1,
      },
    },
    {
      id: "finance.outstanding.default",
      widgetId: "finance.outstanding",
      placement: {
        x: 9,
        y: 3,
        width: 3,
        height: 1,
      },
    },
    {
      id: "finance.account-type-list.default",
      widgetId: "finance.account-type-list",
      placement: {
        x: 0,
        y: 4,
        width: 6,
        height: 4,
      },
    },
    {
      id: "finance.performance-report.default",
      widgetId: "finance.performance-report",
      placement: {
        x: 6,
        y: 4,
        width: 6,
        height: 4,
      },
    },
    {
      id: "finance.cashflow-sankey.default",
      widgetId: "finance.cashflow-sankey",
      placement: {
        x: 0,
        y: 8,
        width: 12,
        height: 6,
      },
    },
    {
      id: "finance.money-position.default",
      widgetId: "finance.money-position",
      placement: {
        x: 0,
        y: 14,
        width: 12,
        height: 8,
      },
    },
    {
      id: "finance.cash-position.default",
      widgetId: "finance.cash-position",
      placement: {
        x: 0,
        y: 22,
        width: 12,
        height: 6,
      },
    },
  ],
};
